import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ICollapseProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ICollapseProps>>
): IComponentSchema<ICollapseProps> => {
  const id = uuidv4();
  const panelId = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Collapse,
    'x-component-props': {
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    properties: props?.properties || {
      [panelId]: {
        type: JsonFieldType.VOID,
        name: panelId,
        'x-designable-id': panelId,
        'x-index': 0,
        'x-component': ComponentType.CollapsePanel,
        'x-component-props': {
          label: 'Panel 1',
          defaultActive: true,
        },
        properties: {},
      },
    },
  };
};
